module.exports = __webpack_public_path__ + "static/media/highFiveRight.d5899df6.png";